import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => {
  const { primary, secondary } = theme.palette;

  return {
    root: {
      display: "flex",
      alignItems: "center",
      cursor: "pointer"
    },
    label: {
      color: primary.main,
      textTransform: "capitalize"
    },
    checkbox: {
      display: "flex",
      justifyContent: "end",
      "& .MuiSvgIcon-root": {
        width: 30,
        height: 30
      }
    },
    secondaryColor: {
      color: secondary.dark,
      "&$checked": {
        color: secondary.dark
      },
      "&.selectAll": {
        color: primary.main,
        "&$checked": {
          color: primary.main
        }
      }
    },
    checked: {}
  };
});
